<div class="card">
  <div class="card-body">
    <h5 class="card-title">WEB EXHIBITION BOOTH</h5>
    <h6 class="card-subtitle mb-2 text-muted">© 株式会社コルボ</h6>
    <p class="card-text">
    </p>
    <dl class="row">
      <dt class="col-sm-3">制作年</dt>
      <dd class="col-sm-9">2020</dd>
    
      <dt class="col-sm-3">プラットホーム</dt>
      <dd class="col-sm-9">WebGL</dd>
    </dl>
    <a href="https://www.colbo.co.jp/" class="btn btn-primary">リンク</a>
  </div>
</div>
